import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { Button, Card } from "antd"
import { TextAreaField } from "components/timenotes/fields/text-area-field"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { useFormikContext } from "formik"
import { useEffect, useState } from "react"
import { SubmitShortcutInfo } from "./submit-shortcut-info"

export const TaskDescriptionField = () => {

  const formik = useFormikContext<TaskFormObject>()

  const [isFocus, setIsFocus] = useState(false)
  const isDescriptionDirty = `${formik.values.description}` != `${formik.initialValues?.description}`

  const [isDescriptionSubmitting, setIsDescriptionSubmitting] = useState(false)

  useEffect(() => {
    // Handle change that triggers the submit
    if (isDescriptionDirty && formik.isSubmitting) {
      setIsDescriptionSubmitting(true)
    } 

    // This means end of submitting
    if (isDescriptionSubmitting == true && formik.isSubmitting == false) {
      if (!formik.errors.description) {
        setIsDescriptionSubmitting(false)
        setIsFocus(false)
      }
    }
  }, [isDescriptionDirty, formik.isSubmitting])

  const handleSubmit = () => {
    if (isDescriptionDirty) {
      formik.submitForm()
    }
  }
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      e.stopPropagation()
      e.preventDefault()

      formik.setFieldValue('description', formik.initialValues.description)
      setIsFocus(false)
    }

    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.stopPropagation()
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <OutsideAlerter
      onClick={() => {
        if (!isDescriptionDirty) {
          setIsFocus(false)
        }
      }}
    >
      <Card
        onFocus={() => setIsFocus(true)}
        bodyStyle={{
          padding: '10px',
        }}
        style={{
          position: 'relative',
          cursor: 'text',
        }}
      >

        <TextAreaField
          name="description"
          placeholder="No description"
          bordered={false}
          onKeyDown={handleKeyDown}
          autoSize={{
            minRows: 2,
            maxRows: 10,
          }}
        />

        {(isFocus || isDescriptionDirty) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}
          >
            <SubmitShortcutInfo />

            <div
              style={{
                display: 'flex',
                gap: '5px'
              }}
            >
              <Button
                onClick={() => {
                  formik.setFieldValue('description', formik.initialValues?.description)
                  setIsFocus(false)
                }}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                loading={formik.isSubmitting && isDescriptionDirty}
                onClick={() => formik.submitForm()}
              >
                Update
              </Button>
            </div>
          </div>
        )}
      </Card>
    </OutsideAlerter>
  )
}